export const reduceToValuesForKey = <T extends object, K extends keyof T, FilterNullish extends boolean = false>(
  list: T[],
  key: K,
  filterNullish?: FilterNullish
): FilterNullish extends true ? NonNullable<T[K]>[] : T[K][] => {
  if (filterNullish) {
    return list.reduce<NonNullable<T[K]>[]>((acc, curr) => {
      if (!curr[key]) {
        return acc;
      }
      acc.push(curr[key]);
      return acc;
    }, []);
  }

  return list.reduce<T[K][]>((acc, curr) => {
    if (key in curr) {
      acc.push(curr[key]);
    }
    return acc;
  }, []) as FilterNullish extends true ? NonNullable<T[K]>[] : T[K][];
};
